<script setup lang="ts">

import { IconCopy } from '@shared/ui/icons'
import { AppSelect } from '@shared/ui/selects'
import { ModalDefault } from '@shared/ui/modals'
import { AppInput } from '@shared/ui/inputs'
import { AppDatePicker } from '@shared/ui/fields'
import { BtnPrimary, BtnSecondary } from '@shared/ui/buttons'

import { useCreatePromocode } from '../../model/create-promocode.hook'

defineOptions({
  name: 'ModalCreatePromocode',
})

const {
  isOpen,
  refStatus,
  refDiscount,
  refExpiresAt,
  refName,
  statusOptions,
  discountOptions,
  isSaving,
  isSaveDisabled,
  save,
  cancel,
} = useCreatePromocode()
</script>

<template>
  <ModalDefault
    :show="isOpen"
    :loading="isSaving"
    title="Create promo code"
    is-close-button
    @click:overlay="cancel"
    @click:close="cancel"
  >
    <div class="modal-promocode">
      <AppSelect
        v-model="refStatus"
        :options="statusOptions"
        label="Status"
        placeholder="Select status"
      />

      <AppSelect
        v-model="refDiscount"
        :options="discountOptions"
        label="Discount"
        placeholder="Select discount"
      />

      <AppDatePicker
        :value="refExpiresAt"
        label="Expires at:"
        placeholder="Eternal"
        @change="refExpiresAt = $event"
      />

      <AppInput
        v-model="refName"
        label="Create promo code"
        placeholder="Promo code name"
      >
        <template #append>
          <IconCopy
            :value="refName"
            tooltip="Click to copy code"
          />
        </template>
      </AppInput>
    </div>

    <template #controls>
      <BtnPrimary
        text="Create"
        color="emerald"
        :disabled="isSaveDisabled || isSaving"
        @click="save"
      />
      <BtnSecondary
        text="Close"
        @click="cancel"
      />
    </template>
  </ModalDefault>
</template>

<style scoped lang="scss" src="./ModalCreatePromocode.scss" />
